/**
 * @generated SignedSource<<63c12da6b2214a3adf86b89b7685cd25>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuMultiSelect_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAppliedFilterUrlLabel_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuMultiSelect_itemSearch";
};
export type SbSharedRefineMenuMultiSelect_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuMultiSelect_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuMultiSelect_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuMultiSelect_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAppliedFilterUrlLabel_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "b9d7710e1359d14e33eae8d618b1d117";

export default node;
